import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCloseFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect width={24} height={24} fill="#C18F81" rx={12} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.805 7.195c.26.26.26.683 0 .943l-8.667 8.667a.667.667 0 1 1-.943-.943l8.667-8.667c.26-.26.682-.26.943 0"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7.195 7.195c.26-.26.683-.26.943 0l8.667 8.667a.667.667 0 1 1-.943.943L7.195 8.138a.667.667 0 0 1 0-.943"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCloseFilled;
